// 路由 /formation/3d — 直接渲染主 FormationPage, 默认 3D 模式
import React from 'react';
import FormationPage from '../FormationPage';
export default function Formation3DPage() {
  return <FormationPage initialView3D={true} />;
}
